import { type FunctionComponent, useMemo } from 'react';
import { VStack } from '@chakra-ui/react';
import cx from 'classnames';
import LivePanelControls from './components/LivePanelControls';
import ScrubberHeaderSection from '../Scrubber/components/ScrubberHeaderSection';
import { type Timestamp } from '../../services/Timestamp';
import { useLiveTimestamp } from '../../hooks/useLiveTimestamp';
import { type OperationViewModel } from '../Map/types';
import type { TargetVessel, VesselPosition } from '../../types';

interface Props {
  targetVessel: TargetVessel;
  isTripsPanelOpen: boolean;
  vesselPositions: VesselPosition[];
  operation: OperationViewModel;
  onTargetLock: (mmsi: string) => void;
  setTimestamp: (timestamp: Timestamp) => void;
  setStartTimestamp: (timestamp: Timestamp) => void;
}

const LivePanel: FunctionComponent<Props> = ({
  isTripsPanelOpen,
  targetVessel,
  vesselPositions,
  operation,
  onTargetLock,
  setTimestamp,
  setStartTimestamp,
}) => {
  const timestamp = useLiveTimestamp();
  const speed = useMemo(() => {
    return vesselPositions?.find(x => x.mmsi === targetVessel?.mmsi)?.speed;
  }, [vesselPositions, targetVessel]);

  const scrubberClasses = cx('scrubber-container', 'collapsed', {
    shrunk: isTripsPanelOpen,
  });

  return (
    <VStack className={scrubberClasses}>
      <LivePanelControls
        isLockedOnTarget={targetVessel.isLockedOnTarget}
        onTargetLock={onTargetLock}
        timestamp={timestamp}
        timezone={operation.timezone}
        vessel={targetVessel}
        isTripsPanelOpen={isTripsPanelOpen}
        operation={operation.name}
        setStartTimestamp={setStartTimestamp}
        setTimestamp={setTimestamp}
      />
      <ScrubberHeaderSection timestamp={timestamp} vessel={targetVessel} speed={speed} timezone={operation.timezone} />
    </VStack>
  );
};

export default LivePanel;
